var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOsWindows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6478 42.3519C78.9466 42.3519 80.0008 43.4061 80.0008 44.7049V77.6461C80.0008 78.3284 79.7043 78.9731 79.196 79.4155C78.7631 79.7967 78.2125 79.999 77.6478 79.999C77.5443 79.999 77.436 79.9943 77.3325 79.9802L39.6854 74.8414C38.5184 74.6814 37.6478 73.6837 37.6478 72.5072V44.7049C37.6478 43.4061 38.702 42.3519 40.0008 42.3519H77.6478ZM30.589 42.3519C31.8878 42.3519 32.9419 43.4061 32.9419 44.7049V71.1425C32.9419 71.8249 32.6455 72.4696 32.1325 72.9167C31.6996 73.2931 31.1537 73.4954 30.589 73.4954C30.4855 73.4954 30.3725 73.4907 30.269 73.4719L2.03367 69.5567C0.86659 69.3967 0.000756999 68.4037 0.000756999 67.2272V44.7049C0.000756999 43.4061 1.05488 42.3519 2.35367 42.3519H30.589ZM30.2671 6.52465C30.94 6.42582 31.6177 6.63286 32.1306 7.07994C32.6483 7.52703 32.94 8.1764 32.94 8.85407V35.2916C32.94 36.5952 31.8906 37.6446 30.5871 37.6446H2.35176C1.05297 37.6446 -0.00115967 36.5952 -0.00115967 35.2916V12.7694C-0.00115967 11.5976 0.864715 10.5999 2.03176 10.4399L30.2671 6.52465ZM77.333 0.0201503C78.0059 -0.0645581 78.6836 0.133067 79.1965 0.58015C79.7048 1.02723 80.0012 1.67194 80.0012 2.34957V35.2907C80.0012 36.5943 78.9471 37.6437 77.6483 37.6437H40.0012C38.7024 37.6437 37.6483 36.5943 37.6483 35.2908V7.48836C37.6483 6.3119 38.5141 5.31894 39.6859 5.15894L77.333 0.0201503Z",
    fill: ""
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOsWindows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/os_windows.a7cb050ee404273f416e8f6044306bf5.svg";